import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SplitViewService } from '@ebw-monorepo/utils';
import { SplitViewConf } from 'libs/ng-components/utils/src/lib/models/split-view-conf';
import { Feature } from 'ol';
import { BehaviorSubject, Subject, distinctUntilChanged } from 'rxjs';
import { FeatureViewerDetailsComponent } from '../components/feature-viewer/feature-viewer-details/feature-viewer-details.component';
import { FeatureActionEvent } from '../models/feature-action-event';
import { FeatureNode } from '../models/feature-note';
import { FeatureSelectService } from './feature-select.service';

@Injectable({
  providedIn: 'root'
})
export class FeatureViewerService {
  public features$: BehaviorSubject<Feature[]> = new BehaviorSubject(null);
  public selectedNode$: Subject<FeatureNode> = new Subject();
  public nodeAction$: Subject<FeatureActionEvent> = new Subject();
  private _contextId = 'feature_viewer_detail';
  private _splitViewConf: SplitViewConf = {
    title: 'Elenco elementi',
    icon: 'featured_play_list'
  };
  constructor(
    private _featureSelectService: FeatureSelectService,
    private _splitViewService: SplitViewService,
    private _snackBar: MatSnackBar
  ) {
    this._featureSelectService.featuresSelectedChanged$.pipe(distinctUntilChanged()).subscribe({
      next: (features) => {
        if (features.length > 0) {
          this.features$.next(features);
          this._splitViewService.show(FeatureViewerDetailsComponent, this._contextId, features, this._splitViewConf);
        } else {
          // mostro errore
          this._snackBar.open('Nessun dato presente', null, {
            duration: 3000
          });
          this._destroyOwnSplitView();
        }
      }
    });
  }

  public clearFeatures() {
    this.features$.next(null);
  }

  /** Chiude il dettaglio degli elementi, se è quello mostrato nella vista divisa */
  public close() {
    this._destroyOwnSplitView();
    this.clearFeatures();
  }

  private _destroyOwnSplitView() {
    if (this._splitViewService.contextId && this._splitViewService.contextId === this._contextId) {
      this._splitViewService.destroy();
    }
  }

  public notifySelectedNode(node: FeatureNode) {
    this.selectedNode$.next(node);
  }

  public notifyNodeAction(event: FeatureActionEvent) {
    this.nodeAction$.next(event);
  }
}
